module.exports = __webpack_public_path__ + "static/media/yolov3.9b235650.png";